import { render, staticRenderFns } from "./pop-personal.vue?vue&type=template&id=edc11390&scoped=true"
import script from "./pop-personal.vue?vue&type=script&lang=js"
export * from "./pop-personal.vue?vue&type=script&lang=js"
import style0 from "./pop-personal.vue?vue&type=style&index=0&id=edc11390&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc11390",
  null
  
)

export default component.exports